export const isInWebView = () => typeof (window as any)?.ReactNativeWebView?.postMessage === 'function'

export const doPostMessage = (data: any, type: string = 'default'): any => {
    if (!isInWebView()) return;

    let resData: any = data;

    if (typeof data === 'string') {
        try {
            resData = JSON.parse(data);
        } catch (e) { }
    } else {
        resData = data;
    }

    return (window as any).ReactNativeWebView.postMessage(JSON.stringify({ data: resData, type }));
}